export enum SearchLabelType {
  SHORT = 'short',
  LONG = 'long',
}

export enum SearchType {
  // Organization & Fleet Management
  ORG = 'org',
  HUB = 'hub',
  FLEET = 'fleet',

  // Vehicle Identification
  VIN = 'vin',
  ID = 'id',
  ASSET = 'asset',
  SERIAL_NUMBER = 'serialNumber',
  LICENSE_PLATE = 'licensePlate',
  CAMERA_ID = 'cameraId',
  ATTACHED_VEHICLE_NAME = 'attachedVehicleName',
  COMBINED_VEHICLE_SEARCH = 'combinedVehicleSearch',

  // OnStar & Pending Vehicle Management
  FAN = 'fan',
  ONSTAR_ACCOUNT_NUMBER = 'onstarAccountNumber',
  STATION_ID = 'stationId',
  REVIEW_REASON = 'reviewReason',
  CONNECTION_STATUS = 'connectionStatus',
  VEHICLE_YEAR = 'vehicleYear',
  VEHICLE_MODEL = 'vehicleModel',

  // User Management
  USER_EMAIL = 'userEmail',
  USER_NAME = 'userName',
  EMAIL = 'email',

  // Operations & Scheduling
  OPERATOR = 'operator',
  DRIVER = 'driver',
  ORDER = 'order',
  SCHEDULE_NAME = 'scheduleName',

  // Alerts & Monitoring
  ALERT_TYPE = 'alertType',

  // Infrastructure
  CHARGE_STATION = 'chargeStation',
  GEOFENCES_SEARCH = 'geofencesSearch',

  // Other
  FILE_NAME = 'fileName',
  MULTIPLE_SEARCH = 'multipleSearch',
}

export interface SearchBarProps {
  onSearch: (searchType: SearchType, input: string) => void;
  searchTypes?: SearchType[];
  searchInput?: string;
  withoutSearchTypeSelector?: boolean;
  onClear?: (input?: string) => void;
  initialSearchType?: SearchType;
  dataTestId?: string;
  isFullWidthSearchBar?: boolean;
  useAltInputBackground?: boolean;
  hideSearchByPrefix?: boolean;
  placeholder?: string;
  /** When true, invokes onSearch on each input change instead of requiring Enter. */
  searchOnInputChange?: boolean;
}
